import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Heading,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Card,
  CardBody,
  CardHeader,
} from "@chakra-ui/react";
import axios from "../../axiosConfig";
import WidgetForm from "./WidgetForm";
import WidgetStepsList from "./WidgetStepsList";
import ChecklistItemsList from "./ChecklistItemsList";

import WidgetAttachmentUploader from "./WidgetAttachmentUploader";
import WidgetAttachmentsList from "./WidgetAttachmentsList";

const WidgetEdit = () => {
  const { widgetId } = useParams();
  const navigate = useNavigate();
  const [widget, setWidget] = useState(null);
  const [resourcesRefreshKey, setResourcesRefreshKey] = useState(0); // ✅ NEW

  const fetchWidget = async () => {
    try {
      const res = await axios.get(`/widgets/${widgetId}`);
      setWidget(res.data);
    } catch (error) {
      console.error("Error fetching widget:", error);
    }
  };

  useEffect(() => {
    fetchWidget();
  }, [widgetId]);

  const handleUpdateWidget = async (widgetData) => {
    try {
      await axios.put(`/widgets/${widgetId}`, { widget: widgetData });
      navigate("/app/widget");
    } catch (error) {
      console.error("Error updating widget:", error);
    }
  };

  if (!widget) return <Text>Loading...</Text>;

  return (
    <Box mx="auto" p={6} maxW="container.2xl">
      <Card>
        <CardHeader>
          <Heading as="h2" size="lg">
            Edit Widget: {widget.title}
          </Heading>
          <Text fontSize="lg" color="gray.500">
            Manage content, steps, checklist items, and resources
          </Text>
        </CardHeader>

        <CardBody>
          <Tabs variant="enclosed">
            <TabList>
              <Tab>Widget Details</Tab>
              <Tab>Steps</Tab>
              <Tab>Checklist Items</Tab>
              <Tab>Resources</Tab>
            </TabList>

            <TabPanels>
              <TabPanel>
                <WidgetForm
                  initialData={widget}
                  onSubmit={handleUpdateWidget}
                  onCancel={() => navigate("/app/widget")}
                />
              </TabPanel>

              <TabPanel>
                <WidgetStepsList widgetId={widgetId} />
              </TabPanel>

              <TabPanel>
                <ChecklistItemsList widgetId={widgetId} />
              </TabPanel>

              {/* ✅ RESOURCES */}
              <TabPanel>
                <Heading size="md" mb={4}>
                  Widget Resources
                </Heading>

                <WidgetAttachmentUploader
                  widgetId={widgetId}
                  onUploaded={() =>
                    setResourcesRefreshKey((k) => k + 1)
                  }
                />

                <Box mt={6}>
                  <Heading size="sm" mb={2}>
                    Existing Resources
                  </Heading>

                  <WidgetAttachmentsList
                    widgetId={widgetId}
                    refreshKey={resourcesRefreshKey}
                  />
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </CardBody>
      </Card>
    </Box>
  );
};

export default WidgetEdit;